import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { usePerformanceDetailReport } from "@/hooks/reports/performance-detail-report.hook";
import { cn } from "@/lib/utils";
import { FC, HTMLAttributes } from "react";
import { useParams } from "react-router-dom";
import DimensionDetailsTable from "./dimension-details-table";

type DimensionDetailsCardProps = HTMLAttributes<HTMLDivElement>;

const DimensionDetailsCard: FC<DimensionDetailsCardProps> = ({
  className,
  ...props
}) => {
  const { data: userProfile } = useCurrentUserProfile();

  const { quizId } = useParams();

  const { data: quiz } = useQuizById({
    companyId: userProfile?.companyId || "",
    applicationQuizId: quizId || "",
  });

  const {
    data: report,
    error: reportError,
    isLoading: isReportLoading,
  } = usePerformanceDetailReport({
    companyId: userProfile?.companyId || "",
    applicationQuizId: quiz?.id || "",
  });

  const dimensionResults = report?.dimensionsResult || [];

  if (reportError) {
    throw reportError;
  }

  return (
    <Card
      className={cn(className, "mt-6 rounded-xl px-5 py-3 pb-8")}
      {...props}
    >
      <p className="mb-12 mt-2 text-xl font-bold text-[#13171B]">
        Descripción por dimensiones
      </p>

      {report && (
        <div className="grid grid-cols-2 gap-x-12 gap-y-16">
          {dimensionResults.map((dimension, index) => (
            <DimensionDetailsTable key={index} dimensionResult={dimension} />
          ))}
        </div>
      )}

      {isReportLoading && (
        <div className="grid grid-cols-2 gap-x-12 gap-y-16">
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton key={index} className="h-40 w-full rounded-2xl" />
          ))}
        </div>
      )}
    </Card>
  );
};

export default DimensionDetailsCard;
